var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#00D994",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#00D994",
    strokeOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 10.125H14.8125V9.05357C14.8125 7.575 13.5525 6.375 12 6.375C10.4475 6.375 9.1875 7.575 9.1875 9.05357V10.125H8.625C8.00625 10.125 7.5 10.6071 7.5 11.1964V16.5536C7.5 17.1429 8.00625 17.625 8.625 17.625H15.375C15.9937 17.625 16.5 17.1429 16.5 16.5536V11.1964C16.5 10.6071 15.9937 10.125 15.375 10.125ZM12 14.9464C11.3812 14.9464 10.875 14.4643 10.875 13.875C10.875 13.2857 11.3812 12.8036 12 12.8036C12.6188 12.8036 13.125 13.2857 13.125 13.875C13.125 14.4643 12.6188 14.9464 12 14.9464ZM10.3125 10.125V9.05357C10.3125 8.16429 11.0663 7.44643 12 7.44643C12.9338 7.44643 13.6875 8.16429 13.6875 9.05357V10.125H10.3125Z",
    fill: "#00D994",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1210ddf6cee217101011c0127d683e78.svg";
export { ForwardRef as ReactComponent };